import React from 'react';
import { Reveal } from '../Reveal';
import { Button } from '../Button';
import { useLayout } from '../../contexts/LayoutContext';
type HookScreenProps = {
  onNext: () => void;
};
export function HookScreen({
  onNext
}: HookScreenProps) {
  const {
    compact,
    wide
  } = useLayout();
  return <div className={`flex min-h-full flex-col ${compact ? 'pb-6 pt-14' : 'justify-center py-10'}`} data-id="element-86" data-mp="25yevbj3qyh8f">
      <Reveal data-id="element-87" data-mp="2axi155rjwrhg">
        <p className="flex items-center gap-2.5 text-xs font-semibold uppercase tracking-[0.18em] text-accent" data-id="element-88" data-mp="2avykhe1zgef5">
          <span className="h-2 w-2 rounded-full bg-accent-fill" aria-hidden="true" data-id="element-89" data-mp="2furwf21mfxd7" />
          New Phase 3 data
        </p>
      </Reveal>
      <Reveal delay={0.06} data-id="element-90" data-mp="2kp5mqq1ffeb0">
        <h1 className={`mt-6 max-w-5xl font-display font-light tracking-[-0.035em] text-ink ${compact ? 'text-[2.75rem] leading-[1.04]' : wide ? 'text-[5.75rem] leading-[1]' : 'text-7xl leading-[1.02]'}`} data-id="element-91" data-mp="2pme3qnau9cao">
          How much lung function was preserved at Week&nbsp;52?
        </h1>
      </Reveal>
      <Reveal delay={0.12} data-id="element-92" data-mp="118347n896vch">
        <p className="mt-7 text-base text-muted" data-id="element-93" data-mp="1146ykyeif7nm">FIBRONEER-IPF · JASCAYD®</p>
      </Reveal>

      {!compact && <Reveal delay={0.18} data-id="element-94" data-mp="s5lgt5gv3wnw">
          <Button className="mt-10" onClick={onNext} data-id="element-95" data-mp="s6wjf1ykmydf">
            Explore the data
          </Button>
        </Reveal>}

      <Reveal delay={0.3} className={compact ? 'mt-auto pt-14' : 'mt-20 max-w-5xl'} data-id="element-96" data-mp="n8laquk0itws">
        <div aria-hidden="true" data-id="element-97" data-mp="1kt7n4lhh5feg">
          <div className="h-px bg-hairline" data-id="element-98" data-mp="1kwbx5zhmf5d1" />
          <div className="mt-3 flex justify-between text-xs text-faint" data-id="element-99" data-mp="1fwh53sm409qe">
            <span data-id="element-100" data-mp="1b4fz2ofjbf8t">Baseline</span>
            <span data-id="element-101" data-mp="1b3o33ci0zfi0">Week 52</span>
          </div>
        </div>
      </Reveal>

      {compact && <Reveal delay={0.18} className="pt-8" data-id="element-102" data-mp="164l8yn3l2tot">
          <Button fullWidth onClick={onNext} data-id="element-103" data-mp="163s5pw3u2mbf">
            Explore the data
          </Button>
        </Reveal>}
    </div>;
}